module.exports = {"markup":"<span class=\"inline-arrow-white-right inline-icon\"><svg xmlns=\\\"http://www.w3.org/2000/svg\\\" width=\\\"30\\\" height=\\\"30\\\"><path fill=\\\"#fff\\\" d=\\\"M22.8 14.6L15.2 7l-.7.7 5.5 6.6H6v1.5h14l-5.5 6.6.7.7 7.6-7.6v-.9\\\"/></svg></span>"}


//////////////////
// WEBPACK FOOTER
// ./dev/webpack-loaders/svg-loader!./static/src/inline-svgs/icon/arrow-white-right.svg
// module id = 566
// module chunks = 0